<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
      <span *ngIf="!showInputs">My Actual Task</span>
      <span *ngIf="showInputs">Actual Task</span>
    </h5>
  </div>
  <div id="mainContent" class="container">
    <div class="modal-body mt-2">
      <div class="row" *ngIf="showInputs">
        <div class="col-sm-5">
          <div class="row">
            <div class="col-sm-4">
              <label>Employee Status<span class="text-danger">*</span></label>
            </div>
            <div class="col-sm-6">
              <select class="form-control form-control-xs mt-1" id="empStatus" name="empStatus"
                (change)="loadEmployeeProfiles()" [(ngModel)]="selectEmpStatus">
                <option value="1">Active</option>
                <option value="0">Closed</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="row">
            <div class="col-sm-4">
              <label>Employee Name <span class="text-danger">*</span></label>
            </div>
            <div class="col-sm-6">
              <select class="form-control form-control-xs mt-1" id="empName" name="empName" [(ngModel)]="selectEmpName"
                (change)="onEmployeeSelect()">
                <option value="">Select Employee</option>
                <option *ngFor="let emp of employeeList" [ngValue]="emp">
                  {{ emp.firstName }} {{ emp.middleName }} {{ emp.lastName }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="showInputs">
        <div class="col-sm-5">
          <div class="row">
            <div class="col-sm-4">
              <label>Branch <span class="text-danger">*</span> </label>
            </div>
            <div class="col-sm-6">
              <div class="input-group">
                <input class="form-control form-control-xs" id="branch" name="branch" [(ngModel)]="selectedBranch" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-5">
          <div class="row">
            <div class="col-sm-4">
              <label>Client Status<span class="text-danger">*</span></label>
            </div>
            <div class="col-sm-6">
              <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedClientStatus"
                (change)="loadClientDetails()">
                <option value="">Select Client Status</option>
                <option value="Active">Active</option>
                <option value="Dormant">Closed</option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">Client <span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectClient" #designateClient="ngModel">
                  <mat-option (click)="selectAllClient(designateClient, clientList)" [value]="0">Select All
                  </mat-option>
                  <mat-option (click)="onSelectClient()" #item *ngFor="let client of clientList" [value]="client">
                    {{ client.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">Assignment <span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectedAssignment" #designateAssignment="ngModel">
                  <mat-option (click)="selectAllAssignment(designateAssignment, assignmentList)" [value]="0">Select All
                  </mat-option>
                  <mat-option (click)="onSelectAssignment()" #item *ngFor="let assignment of assignmentList"
                    [value]="assignment">
                    {{ assignment.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">Financial Year<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedFinancialYear">
                <option value="">Select Year</option>
                <option *ngFor="let finance of financialList" [ngValue]="finance">
                  {{ finance.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>


      <div class="row mt-3">
        <div class="col-sm-2">
          <button class="btn btn-sm btn-block btn-outline-theme" (click)="onViewReport()">
            View Details
          </button>
        </div>
        <div class="col-sm-2" *ngIf="showExportToExcelButton">
          <button (click)="exportToExcelMyActualTask()" class="btn btn-sm btn-block btn-outline-theme">
            <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
          </button>
        </div>
        <div class="col-sm-2" *ngIf="showExportToExcelButton">
          <button (click)="exportAsPDFMyActualTask()" class="btn btn-sm btn-block btn-outline-theme">
            <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
          </button>
        </div>
      </div>
    </div>
  </div>
  <br>
  <div class="container" id="mainContent">
    <div *ngIf="reportList.length>0" id="elementsForPDF">
      <div class="row justify-content-center text-center pt-3">
        <span class="bg-theme-title">P G BHAGWAT LLP, Chartered Accountants
        </span>
      </div>
      <div class="row justify-content-center text-center ">
        <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
      </div>


      <div class="row justify-content-center text-center mt-2">
        <span class="bg-theme-title">My Actual Task</span>
      </div>
      <div class="row justify-content-center text-center">
        <span class="bg-theme-title">AsgForFY : {{ selectedFinancialYear.name }}</span>
      </div>
      <div class="pt-2 pb-2">
        <table class="table table-bordered table-sm table-striped">
          <thead>
            <tr>
              <th>Client Name</th>
              <th>Assignment </th>
              <th>Task </th>
              <th>Actual Days</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let clientDetail of reportList;let clientIndex=index;let clientCount=count;">
              <ng-container
                *ngFor="let assignmentDetail of clientDetail.assignments;let assignmentIndex=index;let assignmentCount=count;">
                <ng-container *ngFor="let taskDetail of assignmentDetail.task;let taskIndex=index;let taskCount=count;">
                  <tr *ngIf="assignmentIndex==0 && taskIndex==0">
                    <td [attr.rowspan]="setRowSpanForBranchDetails(clientDetail)+assignmentCount">
                      {{clientDetail.client}}</td>
                    <td [attr.rowspan]="taskCount">{{assignmentDetail.assignment}}</td>
                    <td>{{taskDetail.task}}</td>
                    <td>{{taskDetail.days}}</td>
                  </tr>
                  <tr *ngIf="assignmentIndex!=0 && taskIndex==0">
                    <td [attr.rowspan]="taskCount">{{assignmentDetail.assignment}}</td>
                    <td>{{taskDetail.task}}</td>
                    <td>{{taskDetail.days}}</td>
                  </tr>
                  <tr *ngIf="taskIndex!=0">
                    <td>{{taskDetail.task}}</td>
                    <td>{{taskDetail.days}}</td>
                  </tr>
                  <tr *ngIf="taskIndex==taskCount-1" style="background-color: #e1f4f7">
                    <td>Total</td>
                    <td></td>
                    <td>{{getClientWiseTaskTotal(assignmentDetail)}}</td>
                  </tr>
                  <tr *ngIf="taskIndex==taskCount-1 && assignmentIndex==assignmentCount-1 && clientIndex==clientCount-1"
                    style="background-color: #e1f4f7">
                    <td>Total</td>
                    <td></td>
                    <td></td>
                    <td>{{allDaysTotal}}</td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>